import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Coupons from './pages/Coupons';
import FAQ from './pages/FAQ';
import Space from './pages/Space';
import ScrollToTop from './common/ScrollToTop';
import { MetaPageViewTracker } from './hooks/useMetaTracking';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <MetaPageViewTracker />
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/servicos" element={<Services />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/cupons" element={<Coupons />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/nosso-espaco" element={<Space />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;